import { ChangeDetectionStrategy, Component, effect, input, output } from '@angular/core'
import { NgClass } from '@angular/common'
@Component({
  selector: 'bottom-sheet-modal',
  imports: [NgClass],
  standalone: true,
  templateUrl: './bottom-sheet-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BottomSheetModalComponent {
  closed = output<void>()

  open = input.required<boolean>()

  constructor() {
    // Reacciona a cambios en open()
    effect(() => {
      if (this.open()) {
        document.body.classList.add('overflow-hidden')
      } else {
        document.body.classList.remove('overflow-hidden')
      }
    })
  }
  close(event?: MouseEvent) {
    if (event) event.stopPropagation()
    this.closed.emit()
  }
}
